import {
  Component,
  ChangeDetectionStrategy,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'ag1-bettabase-error',
  templateUrl: './ag1-bettabase-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Ag1BettabaseErrorComponent {
  readonly errorName = input<string>('An error occurred');
  readonly errorMessage = input<string>('An unexpected error occurred');

  readonly errorIcon = computed(() => {
    switch (this.errorName().toLowerCase()) {
      case 'chart timed out':
        return '⏳';
      case 'no data to display':
        return '🪹';
      case 'too much data to display (ram risk)':
        return '📈';
      case 'server error':
        return '🖥️';
      case 'unauthorized':
        return '🔒';
      default:
        return '⚠️';
    }
  });
}
